
import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { AuthConfig, OAuthModule, OAuthModuleConfig, OAuthStorage } from 'angular-oauth2-oidc';
import { environment } from 'environments/environment';
import { IdentityAuthStorage } from './identity-auth-storage';
import { SigninOidcComponent } from './signin-oidc/signin-oidc.component';
import { SignoutOidcComponent } from './signout-oidc/signout-oidc.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpLoaderFactory } from 'app/app.module';

const configAuthZero: AuthConfig = environment.ssoConfig;

export function authConfigFactory(): OAuthModuleConfig {
  return {
    resourceServer: {
      allowedUrls: [environment.usersApiUrl.toLowerCase()],
      sendAccessToken: true,
    }
  };
}

@NgModule({
  imports: [
    HttpClientModule,
    OAuthModule.forRoot(),
    MatProgressBarModule,
    MatCardModule,
    CommonModule, 
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
  }),
  ],
  declarations: [
    SigninOidcComponent,
    SignoutOidcComponent
  ],
  exports: [],
  providers: [
    { provide: AuthConfig, useValue: configAuthZero },
    { provide: OAuthModuleConfig, useFactory: authConfigFactory },
    { provide: OAuthStorage, useValue: new IdentityAuthStorage(sessionStorage, window.location.origin) }
  ]
})
export class AuthModule { }
